import { render, staticRenderFns } from "./MarketingCenterTemplateCard.vue?vue&type=template&id=788e130c&scoped=true&"
import script from "./MarketingCenterTemplateCard.vue?vue&type=script&lang=ts&"
export * from "./MarketingCenterTemplateCard.vue?vue&type=script&lang=ts&"
import style0 from "./MarketingCenterTemplateCard.vue?vue&type=style&index=0&id=788e130c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788e130c",
  null
  
)

export default component.exports